module.exports = __webpack_public_path__ + "img/pic1.9b115340.jpg";